import React from "react";
import StatusIndicator from "./status";
import { CopyValue } from "../..";
import { approvalQueueCopy } from "../../../Utils/approvalRuleCopy";

function ApprovalStatus({ status, id, trail, inSequence }) {
	const progress = status === "pending" ? approvalQueueCopy(trail, inSequence) : null;
	return (
		<div className="p-2 border-t bg-whitish">
			<div className="flex-center-between gap-2">
				{id ? <CopyValue className="text-xxs">{id}</CopyValue> : <span />}
				<StatusIndicator status={status} label={progress?.badge} />
			</div>
			{progress?.note ? <div className="mt-1 text-xxs text-secondary">{progress.note}</div> : null}
		</div>
	);
}

export default ApprovalStatus;
